import {useContext, useEffect, useRef, useState} from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import AlertDialogSlide from "../components/DialogsAlerts";

export function useChangesBlocker(
    when,
    {
        title = "Подтверждение",
        description = "У вас есть несохранённые изменения. Уйти со страницы?",
        confirmText = "Да",
        cancelText = "Нет",
    } = {}
) {
    const navigator = useContext(NavigationContext).navigator;
    const [transition, setTransition] = useState(null);
    const unblockRef = useRef(null);

    useEffect(() => {
        if (!when) return;

        unblockRef.current = navigator.block((tx) => {
            setTransition(tx);
        });

        return () => {
            if (unblockRef.current) {
                unblockRef.current();
            }
        };
    }, [navigator, when]);

    const handleConfirm = () => {
        if (transition) {
            if (unblockRef.current) {
                unblockRef.current(); // 🔥 снимаем блокировку
            }
            transition.retry(); // теперь переход сработает
        }
    };

    const handleCancel = () => {
        setTransition(null);
    };

    const dialog = (
        <AlertDialogSlide
            open={!!transition}
            title={title}
            description={description}
            confirmText={confirmText}
            cancelText={cancelText}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
        />
    );

    return { dialog };
}
/*import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

function useBlocker(blocker, when = true) {
    const navigator = useContext(NavigationContext).navigator;

    useEffect(() => {
        if (!when) return;

        const unblock = navigator.block((tx) => {
            const autoUnblockingTx = {
                ...tx,
                retry() {
                    unblock();
                    tx.retry();
                },
            };
            blocker(autoUnblockingTx);
        });

        return unblock;
    }, [navigator, blocker, when]);
}

export function useChangesBlocker(when,text="У вас есть несохранённые изменения. Уйти со страницы?") {
    // блокировка переходов внутри роутера
    useBlocker(
        (tx) => {
            if (window.confirm(text))
            {
                tx.retry();
            }
        },
        when
    );

    // блокировка обновления/закрытия страницы
    useEffect(() => {
        if (!when) return;

        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ""; 
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [when]);
}*/
